import API_ROUTES from "../constants/api";
import { DEFAULT_ITEMS_PER_PAGE } from "../constants/common";
import HttpUtil from "../http-handler/http-util";

export default class SupplierTypeService {
  static getList(pageNumber = 0, pageSize = DEFAULT_ITEMS_PER_PAGE, key='', sort='', companyId,activeOnly) {
    return HttpUtil.get(API_ROUTES.SUPPLIERTYPE.LIST.replace("<pageNumber>", pageNumber)
    .replace("<pageSize>", pageSize)
    .replace("<key>", key)
    .replace("<sort>", sort)
    .replace("<companyId>", companyId)
    .replace("<activeOnly>", activeOnly));
  }

  static onSubmit(cId,params) {
    var url = API_ROUTES.SUPPLIERTYPE.SUBMIT.replace("<companyId>", cId);
    return HttpUtil.post(url,params);    
  }
 
}